import { ThumbnailProps } from 'core/thumbnail/thumbnail.props';
import { ThumbnailPresets } from 'core/thumbnail/thumbnail.presets';
import { StyledThumbnail } from './thumbnail.styles';

export const Thumbnail = (props: ThumbnailProps) => {
  const { alt, src, ...others } = { ...ThumbnailPresets, ...props };

  return <StyledThumbnail alt={alt} src={src} {...others} />;
};
